export const STATUS_APPEND = 'status/actions/append';
export const STATUS_REMOVE = 'status/actions/remove';

export const REFRESH_SIDEBAR = 'refresh/sidebar';

export function appendStatus(message, type, action) {
  return {
    type: STATUS_APPEND,
    payload: {
      m: message,
      t: type,
      a: action
    }
  };
}

export function removeStatus(queueID) {
  return {
    type: STATUS_REMOVE,
    payload: queueID
  };
}

export function refreshSidebar(key) {
  return {
    type: REFRESH_SIDEBAR,
    payload: key
  };
}
